<template>
  <div>
    <button class="btn btn-secondary btn-block text-white" @click="downloadPosters()">
      <i v-if="loading" class="fas fa-circle-notch fa-spin"></i>
      {{ (loading) ? 'Baixando' : 'Baixar imagem'}}
    </button>
  </div>
</template>

<script>
  export default {
    name: "download-posters",

    props: {
      downloadUrl: String,
    },

    computed: {
      selectedPosters() {
        return this.$store.getters['printPosters/getSelectedPosters'];
      },
    },

    data() {
      return {
        loading: false,
      }
    },

    methods: {
      downloadPosters() {
        this.loading = true;

        this.downloadFromBackEnd();

        // this.getPostersContent().then(() => {
        //   this.downloadFromFrontEnd();
        // }).finally(() => this.loading = false);
      },

      getPostersContent() {
        const payload = {posters: this.selectedPosters.map((poster) => poster.id)};

        return axios.post('/ajax/posters/content', payload).then((response) => {
          (response.data.message)
            ? this.$root.throwFlashMessage('danger', response.data.message)
            : this.$root.$emit('get-posters-content', response.data.data);
        }).catch((error) => {
          this.$root.throwFlashMessage('danger', 'Houve um problema ao carregar os cartazes');
        });
      },

      downloadFromFrontEnd: _.debounce(function () {
        let promises = this.selectedPosters.map((poster) => {

          setTimeout(function () {
            html2canvas(document.getElementById(`canvas-${poster.id}`), {
              onrendered(canvas) {
                console.log(new Date());
                let download = document.createElement('a');
                download.href = canvas.toDataURL('image/png');
                download.download = poster.id;
                download.click();
              }
            });
          }, 500);
        });

        Promise.all(promises).then(() => this.loading = false);

      }, 1000),

      downloadFromBackEnd() {
        const vm = this;
        let promises = this.selectedPosters.map((poster) => {
          return axios({
            method: 'post',
            url: this.downloadUrl,
            data: {poster: poster.id},
            responseType: 'blob',
          }).then((response) => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `${poster.product_code}.png`);
            document.body.appendChild(link);
            link.click();
          }).catch((error) => {
            this.$root.throwFlashMessage('danger', 'Houve um problema ao baixar o cartaz.');
          });
        });

        Promise.all(promises).then(() => vm.loading = false);
      },
    }

  }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// resources/assets/js/components/DownloadPosters.vue